import React, { Component } from 'react';
import { BrowserQRCodeReader } from "@zxing/library";
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
});

export class NewQRScanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "none"
        };
        this.videoRef = React.createRef();
    }

    componentDidMount() {
        if (!this.props.legacyMode) {
            this.handleScan();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.legacyMode !== this.props.legacyMode) {
            if (this.props.legacyMode) {
                this.stop();
            } else {
                this.handleScan();
            }
        }
    }

    componentWillUnmount() {
        this.stop();
    }

    handleScan = async () => {
        let result = "";
        try {
            this.setState({
                display: "block"
            }, async () => {
                const codeReader = new BrowserQRCodeReader();
                const previewElem = this.videoRef.current;
                if (!previewElem) {
                    throw new Error("Video element not found");
                }

                const controls1 = await codeReader.decodeOnceFromVideoDevice(
                    undefined,
                    previewElem
                );
                result = controls1.text;
                if (result) {
                    await this.props.handleScanWebCam(result);
                }
            });
        } catch (error) {
            console.error("Error during QR scan: ", error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to scan QR code. Please try again.'
            });
        }
    }

    stop = () => {
        const videoElement = this.videoRef.current;
        if (videoElement && videoElement.srcObject) {
            const stream = videoElement.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoElement.srcObject = null;
        }
    }

    render() {
        const { display } = this.state;
        return (
            <div id="test-area-qr-code-webcam" style={{ display }}>
                <video
                    ref={this.videoRef}
                    id="video"
                    width="100%"
                    style={{ border: "1px solid gray", borderRadius: "10px", minHeight: "400px", display }}
                >
                </video>
            </div>
        );
    }
}

export default NewQRScanner;
